const scrollElementIntoView = (element: any, offset = 0) => {
  const scrollTop = window.pageYOffset;
  const finalOffset = element.getBoundingClientRect().top + scrollTop + offset;
  window.parent.scrollTo({
    top: finalOffset,
    behavior: 'smooth',
  });
};

export default scrollElementIntoView;const scrollElementIntoView = (element: any, offset = 0) => {
  const scrollTop = window.pageYOffset;
  const finalOffset = element.getBoundingClientRect().top + scrollTop + offset;
  window.parent.scrollTo({
    top: finalOffset,
    behavior: 'smooth',
  });
};

export default scrollElementIntoView;